import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import UploadFasta from "@presentation/components/fasta/UploadFasta";
import { FastaFile } from "@domain/schemas/BI";

export const UploadFastaDialog: React.FC<{
  onUploadSuccess: (uploadedFasta: FastaFile) => void;
  onCancel: () => void;
}> = ({ onUploadSuccess, onCancel }) => {
  return (
    <Dialog title="Upload Fasta" onClose={onCancel}>
      <UploadFasta onUploadSuccess={onUploadSuccess} />
    </Dialog>
  );
};
